import Header from "@/components/Header";
import Profile from "@/components/Profile";
import CompanyTimeline from "@/components/CompanyTimeline";
import CertificatesCarousel from "@/components/CertificatesCarousel";
import SocialLinks from "@/components/SocialLinks";

export default function Home() {
  return (
    <main className="min-h-screen relative z-10">
      <Header />
      <div className="container mx-auto">
        <CompanyTimeline />
        <Profile />
        <CertificatesCarousel />
        <SocialLinks />
      </div>
    </main>
  );
}
